var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-block-editor sleep" }, [
    _c("div", { staticClass: "editor-row customize-editor-minimize" }, [
      _c("div", { staticClass: "editor-row-title" }, [_vm._v("Platform")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btnGroup" },
        _vm._l(["supsis", "email", "whatsapp"], function (platform) {
          return _c(
            "SupsisButton",
            {
              key: platform,
              attrs: {
                classNames:
                  _vm.clone.platform === platform
                    ? "btnGroupItem selected"
                    : "btnGroupItem ",
                primary: _vm.clone.platform === platform,
                ghost: _vm.clone.platform !== platform,
                small: "",
              },
              on: {
                click: function ($event) {
                  _vm.clone.platform = platform
                },
              },
            },
            [_vm._v("\n                " + _vm._s(platform) + "\n            ")]
          )
        }),
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Full Name")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Ad Soyad",
            "show-attributes": true,
            "max-character-count": 500,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.fullname,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "fullname", $$v)
            },
            expression: "clone.fullname",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Email")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Eposta adresi",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.email,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "email", $$v)
            },
            expression: "clone.email",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Phone")]),
        _vm._v(" "),
        _c("small", [
          _vm._v("*E164 formatında giriniz. Örneğin: 905396667744"),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Telefon Numarası",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.phone,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "phone", $$v)
            },
            expression: "clone.phone",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.clone.platform === "whatsapp"
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v("Hangi Whatsapp Kanallarına Eklensin?"),
            ]),
            _vm._v(" "),
            _c("CustomPicker", {
              attrs: {
                "id-key": "_id",
                "label-key": "name",
                items: _vm.whatsappChannels,
                title: "Whatsapp Kanalı Seç",
                multiple: "",
              },
              model: {
                value: _vm.clone.channelIds,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "channelIds", $$v)
                },
                expression: "clone.channelIds",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }